/* L4V v182 — runtime guard for PDP bottom product card text centering.
   Only runs on product pages and only touches recommended/featured product cards. */
(function(){
  // v206 performance guard: this PDP carousel centering patch is only needed on product pages.
  // Returning before any listeners/observers keeps homepage, collections, blog, contact and about lighter.
  if(!document.body || !document.body.classList || !document.body.classList.contains('page-type-product')) return;
  function important(el, prop, value){
    if(el && el.style){ el.style.setProperty(prop, value, 'important'); }
  }
  function centerPdpBottomCards(){
    if(!document.body || !document.body.classList.contains('page-type-product')) return;
    var roots = document.querySelectorAll('section.recommended-products, section.featured-products, [id^="recommended-products-"], [id^="featured-products-"]');
    roots.forEach(function(root){
      root.querySelectorAll('.product-item').forEach(function(card){
        var inner = card.querySelector(':scope > .product-item--inner') || card.querySelector('.product-item--inner');
        var link = card.querySelector('.product-link');
        var title = card.querySelector('.product-item-title');
        var price = card.querySelector('.product-item-price');
        important(inner, 'text-align', 'center');
        important(inner, 'align-items', 'stretch');
        important(link, 'display', 'block');
        important(link, 'width', '100%');
        important(link, 'max-width', '100%');
        important(link, 'text-align', 'center');
        if(title){
          important(title, 'display', 'block');
          important(title, 'width', '100%');
          important(title, 'max-width', '100%');
          important(title, 'box-sizing', 'border-box');
          important(title, 'margin-left', 'auto');
          important(title, 'margin-right', 'auto');
          important(title, 'padding-left', '18px');
          important(title, 'padding-right', '18px');
          important(title, 'text-align', 'center');
          important(title, 'align-items', 'initial');
          important(title, 'justify-content', 'initial');
          important(title, '-webkit-box-pack', 'initial');
          important(title, 'white-space', 'normal');
          important(title, 'overflow', 'visible');
          important(title, 'text-overflow', 'clip');
        }
        if(price){
          important(price, 'display', 'flex');
          important(price, 'width', '100%');
          important(price, 'max-width', '100%');
          important(price, 'box-sizing', 'border-box');
          important(price, 'margin-left', 'auto');
          important(price, 'margin-right', 'auto');
          important(price, 'padding-left', '0');
          important(price, 'padding-right', '0');
          important(price, 'text-align', 'center');
          important(price, 'justify-content', 'center');
          important(price, 'align-items', 'center');
        }
      });
    });
  }
  function schedule(){ centerPdpBottomCards(); setTimeout(centerPdpBottomCards, 250); setTimeout(centerPdpBottomCards, 900); setTimeout(centerPdpBottomCards, 1800); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('load', schedule, {once:true});
  window.addEventListener('resize', centerPdpBottomCards);
  window.addEventListener('orientationchange', function(){ setTimeout(centerPdpBottomCards, 250); });
  /* v187 perf guard: this observer is only needed on product pages where these PDP carousels exist. */
  if(window.MutationObserver && document.body && document.body.classList.contains('page-type-product')){
    var pdpRoots = document.querySelectorAll('section.recommended-products, section.featured-products, [id^="recommended-products-"], [id^="featured-products-"]');
    pdpRoots.forEach(function(root){
      new MutationObserver(function(){ centerPdpBottomCards(); }).observe(root, {childList:true, subtree:true});
    });
  }
})();
